export default "/images/whatsapp.svg?36059aafb144361a96f1a95ba8761ec8";